import { Injectable } from "@angular/core";
import {
	HttpClient,
	HttpHeaders,
} from "@angular/common/http";
import { forkJoin, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { CartaoType, CrmType, PagtoType, PixType } from "../shared/types";

const auth = environment.authorization;

@Injectable({
	providedIn: "root",
})
export class HomeService {
	urlSeguimentos = `${environment.API}seguimentos`;
	urlClientes = `${environment.API}clientes`;
	urlParametros = `${environment.API}parametro/0301/`;
	headers = new HttpHeaders({ authorization: sessionStorage.getItem("token") });
	headers2 = new HttpHeaders({'authorization':auth, 'tenantid':'01,0301', 'x-erp-module':'FAT', 'Accept-Charset':'UTF-8'});
	filial: string = ''

	constructor(private http: HttpClient) { }

	getSeguimentos(coduser: string, portal: string): Observable<any> {
		return this.http.post(
			this.urlSeguimentos,
			{ coduser, portal },
			{ headers: this.headers }
		);
	}

	private getParamsPecas(): Observable<{
		crm: CrmType,
		pagto: PagtoType,
		cartao: CartaoType,
		pix: PixType
	}> {
		const MV_CRM$: Observable<CrmType> = this.http.get<CrmType>(
			`${this.urlParametros}MV_CRMPECA`,
			{ headers: this.headers }
		);

		const MV_PAGTO$: Observable<PagtoType> = this.http.get<PagtoType>(
			`${this.urlParametros}MV_CPECAS`,
			{ headers: this.headers }
		);
		const MV_CARTAO$: Observable<CartaoType> = this.http.get<CartaoType>(
			`${this.urlParametros}MV_CCCREDP`,
			{ headers: this.headers }
		);
		const MV_PIXP$: Observable<PixType> = this.http.get<PixType>(
			`${this.urlParametros}MV_CPPIXP`,
			{ headers: this.headers }
		);

		return forkJoin({
			crm: MV_CRM$,
			pagto: MV_PAGTO$,
			cartao: MV_CARTAO$,
			pix: MV_PIXP$
		});
	}

	private getParamsMotos(): Observable<{
		crm: CrmType,
		pagto: PagtoType,
		cartao: CartaoType,
		pix: PixType
	}> {
		const MV_CRM$: Observable<CrmType> = this.http.get<CrmType>(
			`${this.urlParametros}MV_CRMMOTO`,
			{ headers: this.headers }
		);

		const MV_PAGTO$: Observable<PagtoType> = this.http.get<PagtoType>(
			`${this.urlParametros}MV_CPMOTO`,
			{ headers: this.headers }
		);
		const MV_CARTAO$: Observable<CartaoType> = this.http.get<CartaoType>(
			`${this.urlParametros}MV_CCCREDM`,
			{ headers: this.headers }
		);
		const MV_PIXP$: Observable<PixType> = this.http.get<PixType>(
			`${this.urlParametros}MV_CPPIXM`,
			{ headers: this.headers }
		);

		return forkJoin({
			crm: MV_CRM$,
			pagto: MV_PAGTO$,
			cartao: MV_CARTAO$,
			pix: MV_PIXP$
		});
	}

	private getParamsVeiculos(): Observable<{
		crm: CrmType,
		pagto: PagtoType,
		cartao: CartaoType,
		pix: PixType
	}> {
		const MV_CRM$: Observable<CrmType> = this.http.get<CrmType>(
			`${this.urlParametros}MV_CRMMOTO`,
			{ headers: this.headers }
		);

		const MV_PAGTO$: Observable<PagtoType> = this.http.get<PagtoType>(
			`${this.urlParametros}MV_CPVEIC`,
			{ headers: this.headers }
		);
		const MV_CARTAO$: Observable<CartaoType> = this.http.get<CartaoType>(
			`${this.urlParametros}MV_CCCREDV`,
			{ headers: this.headers }
		);
		const MV_PIXP$: Observable<PixType> = this.http.get<PixType>(
			`${this.urlParametros}MV_CPPIXV`,
			{ headers: this.headers }
		);

		return forkJoin({
			crm: MV_CRM$,
			pagto: MV_PAGTO$,
			cartao: MV_CARTAO$,
			pix: MV_PIXP$
		});
	}

	getSegmentos(): Observable<any> {
		return this.http.get(this.urlParametros + "MV_XPRTSEG", {
			headers: this.headers,
		});
	}

	getParams(segmento: string, filial: string): Observable<{
		crm: CrmType,
		pagto: PagtoType,
		cartao: CartaoType,
		pix: PixType
	}> {
		this.filial = filial

		if (segmento === 'PECAS') {
			return this.getParamsPecas()
		} else if (segmento === 'MOTOS') {
			return this.getParamsMotos()
		} else if (segmento === 'VEICULOS') {
			return this.getParamsVeiculos()
		}
	}

	getLoja(cgc: string, segmento: string): Observable<any> {
		return this.http.post(
			this.urlClientes,
			{ tiporeq: "C", cgc: cgc, segmto: segmento },
			{ headers: this.headers }
		);
	}

	getVend1(segmeto: string): Observable<any> {
		return this.http.get(this.urlParametros + "MV_CVENDP", {
			headers: this.headers,
		});
	}
}
